import styled from 'styled-components'
import { font } from 'lib/core/resources/helpers/styled'
import { heading3 } from 'app/livbrite/resources/theme/css'

export const Title = styled.h1`
  ${heading3}
  text-transform: uppercase;
  color: ${props => props.theme.palette.general.light};
  background: ${props => props.theme.palette.primary.alphaDark};
  padding: 20px 35px;

  > div {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    margin-top: 5px;

    span {
      font: ${font('default', 'normal', '14px/1')};
      text-transform: none;
    }
  }
`
